import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';
import { faqs, processSteps } from '../../content/siteContent';

function Process() {
  return (
    <main>
      <Seo
        title="Admission Process | Vedanskrix College Admission"
        description="Understand the Vedanskrix college admission process from counselling and shortlisting to applications, visa support, and departure planning."
        keywords={['admission process', 'student visa process', 'college application guidance']}
      />

      <section className="ca-page-hero">
        <div className="ca-container">
          <span className="ca-eyebrow">How We Work</span>
          <h1>A simple process that keeps every step more manageable.</h1>
          <p>
            Students often need clarity more than complexity. Our process is designed to keep
            planning, applications, and visa preparation easier to follow.
          </p>
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container ca-timeline">
          {processSteps.map((step) => (
            <article key={step.step} className="ca-timeline__item">
              <div className="ca-timeline__badge">{step.step}</div>
              <div className="ca-timeline__content">
                <h2>{step.title}</h2>
                <p>{step.detail}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="ca-section ca-section--soft">
        <div className="ca-container">
          <div className="ca-section__heading">
            <span className="ca-eyebrow">FAQ</span>
            <h2>Common questions from students and parents.</h2>
          </div>
          <div className="ca-faq-list">
            {faqs.map((item) => (
              <article key={item.question} className="ca-faq-card">
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ca-section">
        <div className="ca-container ca-cta ca-cta--split">
          <div>
            <h2>Want a personalised admission roadmap?</h2>
            <p>Connect with our team and we will help you understand the right next step.</p>
          </div>
          <Link to="/contact" className="ca-button">
            Book A Call
          </Link>
        </div>
      </section>
    </main>
  );
}

export default Process;
